import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TeamAssignmentModel from '../../components/TeamAssignment/TeamAssignmentModel';
import {
  fetchTeamsRequest,
  fetchTeamsSuccess,
  fetchTeamsFailure
} from '../../actions/teamActions';

export const useTeams = (shouldFetch = false) => {
  const dispatch = useDispatch();
  const { teams, loading, error } = useSelector((state) => state.teamReducer);

  const fetchFromApi = useCallback(async () => {
    try {
      dispatch(fetchTeamsRequest());
      const response = await TeamAssignmentModel.getForAll();
      dispatch(fetchTeamsSuccess(response?.team_assignments));
    } catch (err) {
      dispatch(fetchTeamsFailure(err));
    }
  }, [dispatch]);

  useEffect(() => {
    if (!shouldFetch) return;

    fetchFromApi();
  }, [shouldFetch, fetchFromApi]);

  const teamOptions = useMemo(() => {
    if (!Array.isArray(teams)) return [];
    return teams.map((team) => ({
      ...team,
      label: team.name
    }));
  }, [teams]);

  return {
    teams, teamOptions, loading, error
  };
};

export default useTeams;
